module.exports = __webpack_public_path__ + "static/media/coronavirus-research.63aadca3.png";